// components/MDDropzone/UploadedFilePreview.jsx
import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

function UploadedFilePreview({ file, onRemove, layout = "inline", forceLabel }) {
    const fileToRender = Array.isArray(file) ? file[0] : file;
    if (!fileToRender) return null;

    const isString = typeof fileToRender === "string";
    const isFile = typeof File !== "undefined" && fileToRender instanceof File;

    const href = isString
        ? `${process.env.REACT_APP_API_URL}/${fileToRender}`
        : isFile
            ? URL.createObjectURL(fileToRender)
            : "#";

    const filename = isString
        ? fileToRender.split("/").pop()
        : isFile
            ? fileToRender.name
            : "Bilinmeyen";

    const defaultLabel = isString ? "Current File:" : "✅ Uploaded:";
    const label = forceLabel || defaultLabel;
    const color = isString ? "info" : "success";

    if (layout === "stack") {
        // Etiket ÜSTTE, link ALTA
        return (
            <MDBox display="flex" flexDirection="column" alignItems="center">
                <MDTypography variant="caption" color={color} sx={{ fontWeight: "bold" }}>
                    {label}
                </MDTypography>

                <MDTypography variant="caption">
                    <a href={href} target="_blank" rel="noopener noreferrer">
                        {filename}
                    </a>
                    {onRemove && (
                        <span
                            onClick={onRemove}
                            style={{ cursor: "pointer", color: "red", fontWeight: "bold", marginLeft: 6 }}
                            title="Remove file"
                        >
              ×
            </span>
                    )}
                </MDTypography>
            </MDBox>
        );
    }

    // Eski davranış: yan yana (inline)
    return (
        <MDTypography
            variant="caption"
            color={color}
            mt={1}
            display="flex"
            alignItems="center"
            gap="0.5rem"
        >
            {label}{" "}
            <a href={href} target="_blank" rel="noopener noreferrer">
                {filename}
            </a>
            {onRemove && (
                <span
                    onClick={onRemove}
                    style={{ cursor: "pointer", color: "red", fontWeight: "bold", marginLeft: "0.25rem" }}
                    title="Remove file"
                >
          ×
        </span>
            )}
        </MDTypography>
    );
}

UploadedFilePreview.propTypes = {
    file: PropTypes.oneOfType([
        PropTypes.string,
        typeof File !== "undefined" ? PropTypes.instanceOf(File) : PropTypes.any,
        PropTypes.arrayOf(typeof File !== "undefined" ? PropTypes.instanceOf(File) : PropTypes.any),
    ]),
    onRemove: PropTypes.func,
    layout: PropTypes.oneOf(["inline", "stack"]),
    forceLabel: PropTypes.string,
};

export default UploadedFilePreview;
